<template>
<div
  class="pa-0 big-box"
  v-if="data.length !== 0"
>

  <v-simple-table class="coures-table" :class="{tableOneColumn: lessOneColumn}">
    <template v-slot:default>
      <thead>
        <tr>
          <th
            class="text-left pl-6"
            style="min-width: 120px"
            v-for="(course, idx) in headers"
            :key="idx"
          >
            {{ course.text }}
          </th>
        </tr>
      </thead>
      <tbody>
        <TableColumn
          v-for="course in data"
          :course="course"
          :key="course.id"
          :isCourseAdmin="isCourseAdmin"
        />
      </tbody>
    </template>
  </v-simple-table>
</div>
</template>

<script>
import ButtonEdit from "@/components/Buttons/ButtonEdit";
import TableColumn from "@/components/Courses/TableColumn";

export default {
  name: "TableAboutCourse",
  metaInfo() {
    return {};
  },
  props: {
    isCourseAdmin: { type: Boolean, default: false },
    data: { type: Array, default: []}
  },
  components: {
    ButtonEdit,
    TableColumn,
  },
  data() {
    return {
      
    };
  },
  computed: {
    headers() {
      return [
        { text: "" },
        { text: this.$gettext("Holes") },
        { text: this.$gettext("Par") },
        { text: this.$gettext("Course Type") },
        { text: this.$gettext("Course Architect") },
        { text: this.$gettext("Open Date") },
        { text: this.$gettext("Guest Policy") },
        { text: this.$gettext("Weekday Price") },
        { text: this.$gettext("Weekend Price") },
        { text: this.$gettext("Twilight Price") },
        { text: this.$gettext("Fairway") },
        { text: this.$gettext("Green") }
      ]
    },
    course() {
      return this.$store.state.golfcourse.courseDetail;
    },
    lessOneColumn() {
      return this.data.length <= 1
    }
  },
  methods: {
  },

};
</script>
